var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5666 2.99835H0.903112C0.406438 2.99835 6.86646e-05 3.40472 6.86646e-05 3.9014C6.86646e-05 4.39807 0.406438 4.80444 0.903112 4.80444H1.81519V13.4104C1.81519 16.4718 4.30758 18.9642 7.3689 18.9642H12.1008C15.1622 18.9642 17.6546 16.4718 17.6546 13.4104V4.80444H18.5666C19.0633 4.80444 19.4697 4.39807 19.4697 3.9014C19.4697 3.40472 19.0633 2.99835 18.5666 2.99835ZM15.8485 13.4104C15.8485 15.4784 14.1688 17.1581 12.1008 17.1581H7.3689C5.30093 17.1581 3.62127 15.4784 3.62127 13.4104V4.8225H15.8485V13.4104Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50403 14.494C8.0007 14.494 8.40707 14.0877 8.40707 13.591V8.38946C8.40707 7.89279 8.0007 7.48642 7.50403 7.48642C7.00735 7.48642 6.60098 7.89279 6.60098 8.38946V13.591C6.60098 14.0967 7.00735 14.494 7.50403 14.494Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9655 14.494C12.4622 14.494 12.8686 14.0877 12.8686 13.591V8.38946C12.8686 7.89279 12.4622 7.48642 11.9655 7.48642C11.4689 7.48642 11.0625 7.89279 11.0625 8.38946V13.591C11.0625 14.0967 11.4598 14.494 11.9655 14.494Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48626 1.80609H11.9834C12.4801 1.80609 12.8865 1.39972 12.8865 0.903043C12.8865 0.406369 12.4801 0 11.9834 0H7.48626C6.98958 0 6.58321 0.406369 6.58321 0.903043C6.58321 1.39972 6.98958 1.80609 7.48626 1.80609Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.f8bb61075ebd9a5d837507df990aaa67.svg";
export { ForwardRef as ReactComponent };